import React, { useEffect, useState } from 'react';

import Button from '@/components/common/Button/Button';
import { Modal } from '@/components/common/Modal/Modal';

interface ModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onRemove: () => void;
}

export const RemoveItemModel: React.FC<ModalProps> = ({
  isOpen,
  title,
  description,
  onClose,
  onRemove,
}: ModalProps) => {
  const [hideModalChecked, setHideModalChecked] = useState(false);

  useEffect(() => {
    const hideDeleteModal = sessionStorage.getItem('hideDeleteModal');
    if (hideDeleteModal === 'true') {
      setHideModalChecked(true);
    }
  }, []);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setHideModalChecked(checked);
    sessionStorage.setItem('hideDeleteModal', checked.toString());
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      headerTitle={''}
      customContentStyles={{ maxWidth: 430 }}
      hideCloseIcon={true}
    >
      <div className="mx-auto w-auto max-w-lg p-8 lg:max-w-lg">
        <div className="flex w-full flex-col bg-white">
          <span className="pb-4 text-center font-interMedium text-base leading-[22px] text-black">
            {title}
          </span>
          <span className="pb-6 text-center font-interBold text-base text-black">
            {description}
          </span>
          <div className="mb-4 flex items-center justify-center space-x-4">
            <Button theme="tertiary" type="button" onClick={onRemove}>
              <span className="">Remove</span>
            </Button>
            <Button theme="secondary" type="button" onClick={onClose}>
              <span className="">Keep</span>
            </Button>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <input
              type="checkbox"
              checked={hideModalChecked}
              onChange={handleCheckboxChange}
              className="h-4 w-4 accent-success-copy"
            />
            <span>Don’t show this message again</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};
